import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MenuItem from "../MenuItem/MenuItem";
import styles from "./MenuList.module.css";
import { ChevronDown, ChevronUp } from "react-ikonate";
import { useTranslation } from "react-i18next";
import { useIsFreeTrial } from "../../hooks/useUser";
import { getActiveNavHref } from "../../utils/getActiveNavHref";

const HIDDEN_ON_FREE_TRIAL = ["My Orders", "Cart"];

export function MenuList({
  menuItems = [],
  activeTab,
  onTabClick,
  onCollapse,
  cartCount = 0,
}) {
  const { t } = useTranslation();
  const isFreeTrial = useIsFreeTrial();
  const location = useLocation();
  const activeHref = getActiveNavHref(location.pathname);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 587);
  const [isLargeMobile, setIsLargeMobile] = useState(
    window.innerWidth >= 767 && window.innerWidth <= 797
  );
  const [menuVisible, setMenuVisible] = useState(
    window.innerWidth > 587 &&
      !(window.innerWidth >= 767 && window.innerWidth <= 797)
  );

  useEffect(() => {
    const handleResize = () => {
      const isMobileScreen = window.innerWidth <= 587;
      const isLargeMobileScreen =
        window.innerWidth >= 767 && window.innerWidth <= 797;
      setIsMobile(isMobileScreen);
      setIsLargeMobile(isLargeMobileScreen);

      if (isMobileScreen) setMenuVisible(false);
      else if (isLargeMobileScreen) setMenuVisible(false);
      else setMenuVisible(true);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuItemClick = (item) => {
    onTabClick(item);
    if (isMobile || isLargeMobile) {
      toggleMenuVisibility();
    }
  };

  const toggleMenuVisibility = () => {
    setMenuVisible(!menuVisible);
    if (typeof onCollapse === "function") onCollapse();
  };

  const safeMenuItems = (Array.isArray(menuItems) ? menuItems : []).filter(
    (item) => !isFreeTrial || !HIDDEN_ON_FREE_TRIAL.includes(item.label)
  );

  return (
    <div>
      {(isMobile || isLargeMobile) && (
        <div className={styles.activeTabDisplay}>
          <span className={styles.title}>{activeTab.toUpperCase()}</span>
          <span onClick={toggleMenuVisibility} className={styles.menuToggle}>
            {menuVisible ? <ChevronUp /> : <ChevronDown />}
          </span>
        </div>
      )}

      <div
        className={`${styles.MenuList} ${
          menuVisible ? styles.visible : styles.hidden
        }`}
        style={{
          flexDirection: isMobile || isLargeMobile ? "column" : "row",
          gap: isMobile || isLargeMobile ? 0 : "20px",
        }}
      >
        {safeMenuItems
          .filter(
            (item) =>
              ((isMobile || isLargeMobile) && item.label !== activeTab) ||
              (!isMobile && !isLargeMobile)
          )
          .map((item, index, arr) => (
            <div
              key={`${item.label}-${index}`}
              className={`${styles.TopLevelMenuItem} ${
                index !== arr.length - 1 ? styles.separator : ""
              }`}
            >
              <MenuItem
                label={t(item.label).toUpperCase()}
                isActive={
                  activeHref
                    ? item.href === activeHref
                    : activeTab === item.label
                }
                onClick={() => handleMenuItemClick(item)}
                badgeCount={item.label === "Cart" ? cartCount : 0}
              />
            </div>
          ))}
      </div>
    </div>
  );
}

export default MenuList;
